import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState, Fragment } from 'react'

//plugins
import moment from 'moment'
import { Modal, Button, Tabs, Tab, FloatingLabel, Form, Row, Col, Nav, Dropdown, Alert } from 'react-bootstrap';
import { sortable } from 'react-sortable';

//helpers
import Api from 'helpers/Api'
import { useValidation } from 'helpers/Validation'
import { useNestedState } from 'helpers/NestedState'

//providers
import { useLanguageContext } from 'providers/Language'

//misc
import SaveButton from 'components/misc/Button'

function SortableItem(props) {
    return (
        <div {...props}>
            {props.children}
        </div>
    )
}

const SortItem = sortable(SortableItem);

function AddOrEdit(props, ref) {

    const langs = useLanguageContext();

    const defaultData = {
        priority: 1,
    };

    const [state, setState] = useNestedState({
        show: false,
        id: null,
        edit: false,
        data: defaultData,
        tabId: langs.data[0]?.id,
        loading: false,
        onSuccess: null,
        onEntering: null,
        onExiting: null
    });

    const [validations, setValidations] = useValidation();

    const [stores, setStores] = useState([]);

    const validationModalRef = useRef(null);

    useImperativeHandle(ref, () => ({
        add: (groupId = null) => {
            handleShow(groupId);
        },
        edit: (id) => {
            edit(id);
        },
        hide: () => {
            hide();
        },
        onSuccess: fn => {
            setState(prev => ({
                ...prev,
                onSuccess: fn
            }));
        }
    }));

    useEffect(() => {
        loadData();
    }, [state.edit]);

    // useEffect(() => {
    //     if (state.data.details.length === 0) {
    //         setState(prev => ({
    //             ...prev,
    //             data: {
    //                 ...prev.data,
    //                 details: [{}]
    //             }
    //         }))
    //     }
    // }, [state.data.details]);

    // useEffect(() => {
    //     Api.get('store/common/depot')
    //         .then(res => {
    //             if (Array.isArray(res.data)) {
    //                 setStores(res.data);
    //             }
    //         });
    // }, []);

    const show = (onEntering = null) => {
        setState(prev => ({
            ...prev,
            show: true,
            onEntering: onEntering,
        }));
    }

    const hide = (onExiting = null) => {
        setState(prev => ({
            ...prev,
            show: false,
            onExiting: onExiting
        }));
    }

    const handleShow = (groupId) => {
        setState(prev => ({
            ...prev,
            data: {
                ...prev.data,
                group_id: groupId
            },
            id: null,
        }));

        show();
    }

    const handleClose = e => {

        if (e) {
            e.preventDefault();
        }

        setState(prev => ({
            ...prev,
            data: defaultData,
            id: null,
        }));

        setValidations(null);

        hide();
    }

    const edit = id => {
        setState(prev => ({
            ...prev,
            id: id,
            edit: new Date().getTime()
        }));

        show();
    }

    const loadData = () => {
        if (!state.id) {
            return;
        }

        Api.get('depots/show?id=' + state.id)
            .then(res => {

                let data = res.data;

                setState(prev => ({
                    ...prev,
                    data: data
                }))
            });
    }


    const handleSave = e => {
        e.preventDefault();

        if (state.loading) {
            return;
        }

        setState(prev => ({
            ...prev,
            loading: true,
        }));

        setValidations(null);

        let url = state.id ? 'depots/edit' : 'depots/add';

        let data = new FormData(e.target);

        if (state.id) {
            data.append('id', state.id)
        }

        data.append('group_id', state.data.group_id);

        Api.post(url, data, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }).then(res => {
            if (typeof state.onSuccess === 'function') {
                state.onSuccess(res.data)
            }

            hide()
        }).catch(error => {
            const _err = error.response;

            if (_err && _err.status && _err.status === 422) {
                // hide(() => {
                //     let modal = validationModalRef.current;

                //     if (modal) {
                //         modal.open();

                //         modal.onClose(() => {
                //             setValidations(_err.data.errors)
                //             show();
                //         });
                //     }
                // });

                setValidations(_err.data.errors)
            }

        }).finally(() => {
            setState(prev => ({
                ...prev,
                loading: false,
            }));
        });
    }

    const handleInputChange = e => {
        const name = e.target.name
        const value = e.target.value

        setState(name, value, 'data')
    }

    const handleCheckboxChange = e => {
        const name = e.target.name;

        setState(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: prev.data[name] ? false : true
            }
        }));
    }

    const handleDateChange = e => {
        const name = e.target.name + '_ymd'
        const value = e.target.value

        setState(name, value, 'data')
    }

    const handleTabChange = id => {
        setState(prev => ({
            ...prev,
            tabId: Number(id)
        }));
    }


    return (
        <>

            <Modal centered show={state.show} onHide={handleClose} onEntering={state.onEntering} onExiting={state.onExiting}>
                <Form noValidate onSubmit={handleSave}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Склад {state.data?.id && '(ID: ' + state.data.id + ')'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <FloatingLabel label="Име" className="mb-3">
                            <Form.Control
                                type="text"
                                name="name"
                                placeholder="Име"
                                value={state.data.name || ''}
                                onChange={handleInputChange}
                                isInvalid={Boolean(validations && validations.name)}
                            />
                            <Form.Control.Feedback type="invalid">
                                {validations && validations.name && (validations.name[0] || validations.name)}
                            </Form.Control.Feedback>
                        </FloatingLabel>

                        <FloatingLabel label="Описание" className="mb-3">
                            <Form.Control
                                as="textarea"
                                name={`description`}
                                placeholder="Описание"
                                value={state.data.description || ''}
                                onChange={handleInputChange}
                                style={{ height: '100px' }}
                                isInvalid={Boolean(validations?.description)}
                            />
                            <Form.Control.Feedback type="invalid">
                                {validations?.description && (validations.description[0] || validations.description)}
                            </Form.Control.Feedback>
                        </FloatingLabel>

                        <FloatingLabel label="Тежест" className="mb-3">
                            <Form.Control
                                type="number"
                                name={`priority`}
                                placeholder="Тежест"
                                value={state.data.priority || ''}
                                onChange={handleInputChange}
                                isInvalid={Boolean(validations?.priority)}
                            />
                            <Form.Control.Feedback type="invalid">
                                {validations?.priority && (validations.priority[0] || validations.priority)}
                            </Form.Control.Feedback>
                        </FloatingLabel>

                        <Form.Check
                            type="switch"
                            name="can_load"
                            label="Зареждане"
                            value={1}
                            checked={Number(state.data?.can_load) === 1}
                            onChange={handleCheckboxChange}
                        />

                        <Form.Check
                            type="switch"
                            name="can_move_outside"
                            label="Местене"
                            value={1}
                            checked={Number(state.data?.can_move_outside) === 1}
                            onChange={handleCheckboxChange}
                        />

                    </Modal.Body>
                    <Modal.Footer>

                        <Button variant="secondary" onClick={handleClose}>
                            Отказ
                        </Button>
                        <SaveButton
                            loading={state.loading}
                            className="save"
                        />
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}

export default forwardRef(AddOrEdit);
